import React from 'react'

import './style.scss'

class Tag extends React.Component {
  render() {
    return (
      <div
        className={['tag ' + (this.props.className ? this.props.className : '')]}
        dangerouslySetInnerHTML={{__html: this.props.title}}
        onClick={() => this.props.getFactsDataByTag(this.props.tagId)}
      />
    )
  }
}

export default Tag
